import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsMobile } from 'redux/mode/reducers';

// Calculate responsive sidebar width - ensure at least 60px space to the right
const getSidebarWidth = (isMobile: boolean) => {
	const maxSidebarWidth = 280;
	if (!isMobile) return maxSidebarWidth;

	const screenWidth = window.innerWidth;
	const minSpace = 60;
	const availableWidth = screenWidth - minSpace;
	return Math.min(maxSidebarWidth, availableWidth);
};

export const useSidebarWidth = () => {
	const isMobile = useSelector((r: RootReducer) => selectIsMobile(r.mode));
	const [sidebarWidth, setSidebarWidth] = useState(() => getSidebarWidth(isMobile));

	useEffect(() => {
		const updateWidth = () => {
			setSidebarWidth(getSidebarWidth(isMobile));
		};

		// Update immediately when isMobile changes
		updateWidth();

		// Only listen to resize on mobile (where width can change)
		if (isMobile) {
			window.addEventListener('resize', updateWidth);
			return () => window.removeEventListener('resize', updateWidth);
		}
	}, [isMobile]);

	return sidebarWidth;
};
